export const environment = {
  production: true,
  appUrl: 'https://dev.qwikoapps.com',
  baseUrl: 'https://dev.qwikoapps.com',
  apiUrl: 'https://dev-api.qwikoapps.com',
  authUrl: 'https://dev-auth-api.qwikoapps.com/auth',
  firebase: {
    apiKey: 'AIzaSyDs3mheNJoLZPR5gxkguOQCVQhzkgHWH28',
    authDomain: 'dev-auth.qwikoapps.com',
    projectId: 'qwikoappsdev',
    storageBucket: 'qwikoappsdev.firebasestorage.app',
    messagingSenderId: '920109618387',
    appId: '1:920109618387:web:b8d236321eb914ebd6b026',
    measurementId: 'G-B9RCJB43EW',
  },
  recaptcha: {
    sitekey: '6LdFNNkqAAAAAOF25IU0IbTaPPUnnTCAsYedCmGR',
  },
  encryptionKey: 'wdzhgwfVG41P1sTlOx5eO+rTGzX5bNEZZKXgKgbukvk=',
  useEmulators: false,
};
